export { ArtistFeed } from './ArtistFeed';
